module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Two to Nothing")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#foreword"
    }
  }, [_vm._v("Foreword")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#hudson-river-line-springwood-extension"
    }
  }, [_vm._v("Hudson River Line Springwood Extension")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter.-i-edward-g.-demarco-iii"
    }
  }, [_vm._v("Chapter. I: Edward G. Demarco, III")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#wildwood-steel-drum-band-grand-central-station"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Grand Central Station")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter.-ii-chip-callahan"
    }
  }, [_vm._v("Chapter. II: Chip Callahan")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#hudson-river-line-125th-street"
    }
  }, [_vm._v("Hudson River Line – 125"), _c('sup', [_vm._v("th")]), _vm._v(" Street")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter.-iii-margaret-hubbard-winthrop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. III: Margaret Hubbard Winthrop")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#wildwood-steel-drum-band-125th-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – 125"), _c('sup', [_vm._v("th")]), _vm._v(" Street")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter.-iv-arthur-dale",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. IV: Arthur Dale")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hudson-river-line-yonkers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Yonkers")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter.-v-roger-worth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. V: Roger Worth")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#problem-student-vs.-problem-teacher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problem student vs. problem teacher")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#wildwood-steel-drum-band-yonkers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Yonkers")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter.-vi-kate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. VI: Kate")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#hudson-river-line-hasting-on-hudson",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Hasting-on-Hudson")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter.-vii-fall-homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. VII: Fall Homecoming")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#wildwood-steel-drum-band-hastings-on-hudson",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Hastings-on-Hudson")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter.-viii-burton-biedet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. VIII: Burton Biedet")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#hudson-river-line-dobbs-ferry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Dobbs Ferry")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter.-ix-dj-alanzo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. IX: DJ Alanzo")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#wildwood-steel-drum-band-dobbs-ferry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Dobbs Ferry")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter.-x-shakespeare-class",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. X: Shakespeare Class")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#hudson-river-line-irvington",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Irvington")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter.-xi-sir-roger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XI: Sir Roger")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#wildwood-steel-drum-band-irvington",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Irvington")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter.-xii-steady",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XII: Steady")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#hudson-river-line-croton-harmon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Croton-Harmon")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter.-xiii-winter-mudders-i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XIII: Winter Mudders – I")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#wildwood-steel-drum-band-croton-harmon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Croton-Harmon")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter.-xiv-winter-mudders-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XIV: Winter Mudders – II")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#hudson-river-line-philipse-manor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Philipse Manor")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter.-xv-topps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XV: Topps")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#wildwood-steel-drum-band-philipse-manor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Philipse Manor")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter.-xvi-awol",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XVI: AWOL")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#hudson-river-line-sunnysidetarrytown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Sunnyside/Tarrytown")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter.-xvii-the-faculty-lounge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XVII: The Faculty Lounge")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#wildwood-steel-drum-band-sunnyside",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Sunnyside")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter.-xviii-land-winthrop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XVIII: Land Winthrop")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#hudson-river-line-ossining",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Ossining")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter.-xix-teddy-and-the-tutor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XIX: Teddy and the Tutor")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#wildwood-steel-drum-band-ossining",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Ossining")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter.-xx-the-winthrop-red-guard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XX: The Winthrop Red Guard")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#hudson-river-line-peekskill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Peekskill")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter.-xxi-fathers-sons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXI: Fathers Sons")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#wildwood-steel-drum-band-peekskill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Peekskill")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter.-xxii-dean-tracey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXII: Dean Tracey")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hudson-river-line-garrison",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Garrison")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter.-xxiii-rsvp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXIII: RSVP")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#wildwood-steel-drum-band-garrison",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Garrison")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter.-xxiv-millbrook",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXIV: Millbrook")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#hudson-river-line-cold-spring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Cold Spring")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter.-xxv-prom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXV: Prom")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#wildwood-steel-drum-band-cold-spring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Cold Spring")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter.-xxvi-cousin-esther",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXVI: Cousin Esther")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#hudson-river-line-beacon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Beacon")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter.-xxvii-land-offers-rides",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXVII: Land Offers Rides")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#wildwood-steel-drum-band-beacon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Beacon")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter.-xxviii-cousin-esther",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXVIII: Cousin Esther")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#hudson-river-line-poughkeepsie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Poughkeepsie")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter.-xxix-kate-the-graduate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXIX: Kate the Graduate")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#wildwood-steel-drum-band-poughkeepsie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Poughkeepsie")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter.-xxx-crack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXX: Crack!")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#hudson-river-line-winthrop-transfer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Line – Winthrop Transfer")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter.-xxxi-tomas-winstead-19571975",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXXI: Tomas Winstead (1957–1975)")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#springwood-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Springwood Dream")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter.-xxxii-domenic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXXII: Domenic")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#wildwood-steel-drum-band-springwood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wildwood Steel Drum Band – Springwood")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter.-xxxiii-closing-time-1986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXXIII: Closing Time: 1986")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#hudson-river-extension-trainspotting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hudson River Extension – Trainspotting")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter.-xxxiv-charles-callahan-19541994",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter. XXXIV: Charles Callahan (1954–1994)")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#north-of-springwood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North of Springwood")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0